import {
    take,
    takeEvery,
    takeLatest,
    spawn,
    call,
    put,
    select
} from 'redux-saga/effects';
import { takeFirst } from './helperSaga';
import { ACTIONS } from '../actions/actionTypes';
import { push } from 'react-router-redux';
import errorCatcher from '../utils/errorCatcher';
import * as game from '../controllers';

function * GET_QUESTIONS () {
    yield takeLatest(ACTIONS.GET_QUESTIONS, function * (action) {
        try {
            const questions = yield game.question.get(action.payload);
            yield put({type: ACTIONS.SET_QUESTION, payload: questions});
            yield put({type: ACTIONS.SET_QUESTION_LOADING, payload: false});
        } catch (error) {
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

export { GET_QUESTIONS };



// WEBPACK FOOTER //
// ./src/sagas/questionSaga.js